import styled from 'styled-components';

export const NavListDropdown = styled.div`
    position: absolute;
    top: 64px;
    background-color: #f8f8f8;
`;
